import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function () {
  const {t} = useInferableTranslation();

  return (
    <svg
      width="375"
      height="323"
      viewBox="0 0 375 323"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="375"
        height="323"
        fill="#656565"
      />
      <g clipPath="url(#clip0_1926_90152)">
        <rect
          width="375"
          height="323"
          fill="white"
        />
        <mask
          id="mask0_1926_90152"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="-28"
          y="62"
          width="304"
          height="261"
        >
          <rect
            x="-27.1914"
            y="62.4873"
            width="302.361"
            height="260.365"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1926_90152)">
          <path
            d="M62.5879 175.795C52.4644 112.021 9.0208 95.6559 -11.4355 95.445V311.178H374.5V183.388C344.131 183.388 348.56 156.182 323.253 156.182C297.946 156.182 297.946 84.6894 275.169 84.6895C257.443 84.6895 252.393 111.262 234.678 111.262C216.963 111.262 207.472 145.427 204.309 151.754C201.146 158.08 195.451 175.795 178.369 175.795C161.287 175.795 134.714 190.347 129.02 212.491C123.326 234.635 75.2423 255.513 62.5879 175.795Z"
            fill="url(#paint0_linear_1926_90152)"
          />
        </g>
        <g opacity="0.3">
          <mask
            id="mask1_1926_90152"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="275"
            y="62"
            width="130"
            height="261"
          >
            <rect
              width="129"
              height="261"
              transform="matrix(-1 0 0 1 404.5 62)"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask1_1926_90152)">
            <path
              d="M62.5879 175.795C52.4644 112.021 9.0208 95.6559 -11.4355 95.445V311.178H374.5V183.388C344.131 183.388 348.56 156.182 323.253 156.182C297.946 156.182 297.946 84.6894 275.169 84.6895C257.443 84.6895 252.393 111.262 234.678 111.262C216.963 111.262 207.472 145.427 204.309 151.754C201.146 158.08 195.451 175.795 178.369 175.795C161.287 175.795 134.714 190.347 129.02 212.491C123.326 234.635 75.2423 255.513 62.5879 175.795Z"
              fill="url(#paint1_linear_1926_90152)"
            />
          </g>
        </g>
        <path
          d="M275.5 87V319.595"
          stroke="url(#paint2_linear_1926_90152)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask
          id="mask2_1926_90152"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="64"
          width="275"
          height="200"
        >
          <rect
            y="64"
            width="275"
            height="200"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask2_1926_90152)">
          <path
            d="M-11.4355 95.445C9.0208 95.6559 52.4644 112.021 62.5879 175.795C75.2423 255.513 123.326 234.635 129.02 212.491C134.714 190.347 161.287 175.795 178.369 175.795C195.451 175.795 201.146 158.08 204.309 151.754C207.472 145.427 216.963 111.262 234.678 111.262C252.393 111.262 257.443 84.6895 275.169 84.6895"
            stroke="url(#paint3_linear_1926_90152)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <circle
          cx="163"
          cy="179"
          r="5"
          fill="#696969"
        />
        <mask
          id="mask3_1926_90152"
          style={{maskType: 'alpha'}}
          maskUnits="userSpaceOnUse"
          x="275"
          y="64"
          width="100"
          height="200"
        >
          <rect
            x="275"
            y="64"
            width="100"
            height="200"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask3_1926_90152)">
          <path
            d="M-11.4375 95.445C9.01884 95.6559 52.4624 112.021 62.5859 175.795C75.2403 255.513 123.324 234.635 129.018 212.491C134.712 190.347 161.285 175.795 178.367 175.795C195.45 175.795 201.144 158.08 204.307 151.754C207.47 145.427 216.961 111.262 234.676 111.262C252.391 111.262 257.441 84.6895 275.167 84.6895C297.944 84.6894 297.944 156.182 323.251 156.182C348.558 156.182 344.129 183.388 374.498 183.388"
            stroke="url(#paint4_linear_1926_90152)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="4 4"
          />
        </g>
        <circle
          cx="275.5"
          cy="83"
          r="5"
          fill="black"
        />
        <g opacity="0.4">
          <mask
            id="path-12-inside-1_1926_90152"
            fill="white"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M115 128C111.686 128 109 130.686 109 134V152C109 155.314 111.686 158 115 158H157.573L161.649 164.617C162.039 165.252 162.961 165.252 163.351 164.617L167.427 158H189C192.314 158 195 155.314 195 152V134C195 130.686 192.314 128 189 128H115Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M115 128C111.686 128 109 130.686 109 134V152C109 155.314 111.686 158 115 158H157.573L161.649 164.617C162.039 165.252 162.961 165.252 163.351 164.617L167.427 158H189C192.314 158 195 155.314 195 152V134C195 130.686 192.314 128 189 128H115Z"
            fill="#A6A6A6"
            fillOpacity="0.2"
          />
          <path
            d="M157.573 158L158.425 157.476L158.132 157H157.573V158ZM161.649 164.617L162.5 164.093L162.5 164.093L161.649 164.617ZM163.351 164.617L162.5 164.093L162.5 164.093L163.351 164.617ZM167.427 158V157H166.868L166.575 157.476L167.427 158ZM110 134C110 131.239 112.239 129 115 129V127C111.134 127 108 130.134 108 134H110ZM110 152V134H108V152H110ZM115 157C112.239 157 110 154.761 110 152H108C108 155.866 111.134 159 115 159V157ZM157.573 157H115V159H157.573V157ZM162.5 164.093L158.425 157.476L156.722 158.524L160.797 165.142L162.5 164.093ZM162.5 164.093H162.5L160.797 165.142C161.578 166.41 163.422 166.41 164.203 165.142L162.5 164.093ZM166.575 157.476L162.5 164.093L164.203 165.142L168.278 158.524L166.575 157.476ZM189 157H167.427V159H189V157ZM194 152C194 154.761 191.761 157 189 157V159C192.866 159 196 155.866 196 152H194ZM194 134V152H196V134H194ZM189 129C191.761 129 194 131.239 194 134H196C196 130.134 192.866 127 189 127V129ZM115 129H189V127H115V129Z"
            fill="#545454"
            mask="url(#path-12-inside-1_1926_90152)"
          />
        </g>
        <text
          fill="#172430"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="HyundaiSansText"
          fontSize="14"
          fontWeight="600"
          letterSpacing="0em"
        >
          <tspan
            x="141"
            y="148.244"
          >
            2times
          </tspan>
        </text>
        <path
          d="M118 143.5C118 137.125 120.125 135 126.5 135C132.875 135 135 137.125 135 143.5C135 149.875 132.875 152 126.5 152C120.125 152 118 149.875 118 143.5Z"
          fill="#F3A300"
        />
        <path
          d="M126.5 139.25V144.12"
          stroke="white"
          strokeWidth="1.59375"
          strokeLinecap="round"
        />
        <ellipse
          cx="126.5"
          cy="146.771"
          rx="0.796875"
          ry="0.796875"
          fill="white"
        />
        <g opacity="0.4">
          <mask
            id="path-18-inside-2_1926_90152"
            fill="white"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M238 27C234.686 27 232 29.6863 232 33V57C232 60.3137 234.686 63 238 63H268.75L274.193 71.839C274.584 72.4732 275.505 72.4732 275.896 71.839L281.339 63H317C320.314 63 323 60.3137 323 57V33C323 29.6863 320.314 27 317 27H238Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M238 27C234.686 27 232 29.6863 232 33V57C232 60.3137 234.686 63 238 63H268.75L274.193 71.839C274.584 72.4732 275.505 72.4732 275.896 71.839L281.339 63H317C320.314 63 323 60.3137 323 57V33C323 29.6863 320.314 27 317 27H238Z"
            fill="#A6A6A6"
            fillOpacity="0.2"
          />
          <path
            d="M268.75 63L269.601 62.4756L269.308 62H268.75V63ZM274.193 71.839L275.045 71.3147L275.045 71.3147L274.193 71.839ZM275.896 71.839L275.045 71.3147L275.045 71.3147L275.896 71.839ZM281.339 63V62H280.781L280.488 62.4756L281.339 63ZM233 33C233 30.2386 235.239 28 238 28V26C234.134 26 231 29.134 231 33H233ZM233 57V33H231V57H233ZM238 62C235.239 62 233 59.7614 233 57H231C231 60.866 234.134 64 238 64V62ZM268.75 62H238V64H268.75V62ZM275.045 71.3147L269.601 62.4756L267.898 63.5244L273.342 72.3634L275.045 71.3147ZM275.045 71.3147H275.045L273.342 72.3634C274.123 73.6317 275.966 73.6317 276.747 72.3634L275.045 71.3147ZM280.488 62.4756L275.045 71.3147L276.747 72.3634L282.191 63.5244L280.488 62.4756ZM317 62H281.339V64H317V62ZM322 57C322 59.7614 319.761 62 317 62V64C320.866 64 324 60.866 324 57H322ZM322 33V57H324V33H322ZM317 28C319.761 28 322 30.2386 322 33H324C324 29.134 320.866 26 317 26V28ZM238 28H317V26H238V28Z"
            fill="#545454"
            fillOpacity="0.8"
            mask="url(#path-18-inside-2_1926_90152)"
          />
        </g>
        <text
          fill="black"
          xmlSpace="preserve"
          style={{whiteSpace: 'pre'}}
          fontFamily="HyundaiSansText"
          fontSize="14"
          fontWeight="600"
          letterSpacing="0em"
        >
          <tspan
            x="266"
            y="49.8659"
          >
            8times
          </tspan>
        </text>
        <path
          d="M241 44.9386C241 38.2347 243.235 36 249.939 36C256.643 36 258.877 38.2347 258.877 44.9386C258.877 51.6426 256.643 53.8772 249.939 53.8772C243.235 53.8772 241 51.6426 241 44.9386Z"
          fill="#F64854"
        />
        <path
          d="M249.75 41.1464L253.281 41.1464C253.527 41.1464 253.727 41.3465 253.727 41.5933L253.727 45.1238C253.727 45.522 253.246 45.7214 252.964 45.4399L249.434 41.9093C249.152 41.6278 249.352 41.1464 249.75 41.1464Z"
          fill="#F2F4F6"
        />
        <path
          d="M250.57 43.0447L251.834 44.3088L248.042 48.1011C247.693 48.4502 247.127 48.4502 246.778 48.1011V48.1011C246.429 47.752 246.429 47.1861 246.778 46.837L250.57 43.0447Z"
          fill="#F2F4F6"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1926_90152"
          x1="181.532"
          y1="84.6895"
          x2="181.532"
          y2="311.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="#D9D9D9"
            stopOpacity="0.3"
          />
          <stop
            offset="1"
            stopColor="#737373"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1926_90152"
          x1="181.532"
          y1="84.6895"
          x2="181.532"
          y2="311.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="#D9D9D9"
            stopOpacity="0.3"
          />
          <stop
            offset="1"
            stopColor="#737373"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1926_90152"
          x1="276"
          y1="87"
          x2="276"
          y2="319.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="white"
            stopOpacity="0.5"
          />
          <stop
            offset="1"
            stopColor="#999999"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1926_90152"
          x1="275.169"
          y1="158.634"
          x2="-11.4355"
          y2="158.634"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop
            offset="0.493359"
            stopColor="#9CA2A6"
            stopOpacity="0.5"
          />
          <stop
            offset="1"
            stopColor="#37424B"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1926_90152"
          x1="374.498"
          y1="158.633"
          x2="-2.00194"
          y2="159"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#828A90" />
          <stop
            offset="0.25676"
            stopColor="#72797E"
          />
          <stop
            offset="0.555707"
            stopColor="#54595D"
            stopOpacity="0.5"
          />
          <stop
            offset="1"
            stopColor="#26282A"
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="clip0_1926_90152">
          <rect
            width="375"
            height="323"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
